export enum UsageContext {
    usageContextUser = 'usageContextUser',
    usageContextStaff = 'usageContextStaff'
}
